export const environment = {
    production: true,
    apiUrl: "",
    apiVersion: "1.0",
    groupName: "Klasse",
    groupsName: "",
    buildingName: "Schulhaus",
    buildingsName: "Schulhäuser",
    categories: "",
    children: "Kinder",
    firebase: {
        apiKey: "AIzaSyDZ6DkEL7vIskeuzgOkn1BpFAL6-wjZf9g",
        authDomain: "schulestetten-994ab.firebaseapp.com",
        databaseURL: "https://schulestetten-994ab.firebaseio.com",
        projectId: "schulestetten-994ab",
        storageBucket: "schulestetten-994ab.appspot.com",
        messagingSenderId: "976238333490"
    }
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts